import {Injectable} from '@angular/core';
import {UserInfoService} from '@core/modules/authentication/services';
import {Roles} from '@core/modules/role/enums/roles.enum';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  constructor(private userInfoService: UserInfoService) { }

  hasRole(roles: Roles[]): boolean {
    return roles.indexOf(this.userInfoService.getRole()) !== -1;
  }

  getRole(): Roles {
    return this.userInfoService.getRole();
  }

  isRole(role: Roles): boolean {
    return role === this.getRole();
  }
}
